import TopNav from './components/TopNav';
import Hero from './components/Hero';
import Trending from './components/Trending';
import NewsGrid from './components/NewsGrid';
import NewsRows from './components/NewsRows';
import Features from './components/Features';
import FAQ from './components/FAQ';
import About from './components/About';
import TipForm from './components/TipForm';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <>
      <TopNav />
      <main>
        <Hero />
        <Trending />
        <NewsGrid />
        <NewsRows />
        <Features />
        <FAQ />
        <About />
        <TipForm />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}